import { Images } from "../../Common/Images";

const AddVehicleWarningModal = ({ t, onClose, onConfirm }) => {
    return (
        <div
            className="modal"
            style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
            id="dateModal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="dateModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered modal-custom-width">
                <div className="modal-content modal-radius">
                    <div className="modal-body">
                        <div className="close-modal">
                            <a className="close-modal" onClick={onClose}>
                                <img src={Images.Close} alt="Close" />
                            </a>
                        </div>
                        <div className="pt-2">
                            <h5 className="popup-title">{t("warning")}</h5>
                        </div>
                        <div className="form-row mb-3">
                            <label>{t("first_login_settings_msg")}</label>
                        </div>
                        <div className="mt-4">
                            <button
                                className="w-100 min-height-56 main-btn fill-green-btn"
                                onClick={onConfirm}
                                type="button"
                            >
                                {t("confirm")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddVehicleWarningModal;
